// The backend answers 403 { errorCode: 'SUBSCRIPTION_BLOCKED' } to a studio whose Voopty subscription is
// blocked (apps/server/.../subscription-block.middleware.ts). The subscription in the redux store is
// loaded once per page load, so a tab opened before the block still thinks it is active - this is how
// such a tab finds out, on its very next request.
//
// Keep this module free of imports: RestApiService imports it, and anything that reaches
// ServiceLocator (library/Routes does) would close an import cycle back to RestApiService.
export const SUBSCRIPTION_BLOCKED_ERROR_CODE = 'SUBSCRIPTION_BLOCKED';

type Handler = () => void;

let registeredHandler: Handler | null = null;

// RestApiService lives outside React/redux, so the app registers what to do (utils/domain.js).
export function registerSubscriptionBlockedHandler(handler: Handler | null): void {
  registeredHandler = handler;
}

export function handleSubscriptionBlocked(status: number, body: any): void {
  if (status === 403 && body?.errorCode === SUBSCRIPTION_BLOCKED_ERROR_CODE && registeredHandler) {
    registeredHandler();
  }
}
